/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import { graphql } from 'gatsby'
import { Container, Row, Col } from 'components/Grid'
import _get from 'lodash/get'

import Layout from '../layout'
import Header from 'components/Navbar'
import Footer from 'components/Footer'
import Hero from 'components/Hero'
import Info from 'components/Role'
import Components from 'components/components.js'
import SEO from 'components/SEO'

class JobPostEntry extends React.Component {
  state = {
    layout: JSON.parse(this.props.pageContext.layout.content),
    singleRole: this.props.pageContext.singleRole
      ? JSON.parse(this.props.pageContext.singleRole.content)
      : undefined,
  }

  render() {
    const layout = this.state.layout
    const singleRole = this.state.singleRole
    const location = this.props.location
    const { lang, allLanguages } = this.props.pageContext

    const { greenhouseJob: data } = this.props.data
    return (
      <Layout lang={this.props.pageContext.lang}>
        <SEO
          lang={lang}
          pageTitle={data.title}
          schemaLD={[layout.corporate_contact || {}]}
          location={location}
        />
        {layout.header[0] && (
          <Header
            blok={layout.header[0]}
            allLanguages={allLanguages || ['default']}
            lang={lang}
            location={location}
          />
        )}
        <Hero
          blok={{
            title: data.title,
            full_height: false,
            breadcrumbs_show_current: true,
            breadcrumbs_visible: true,
            breadcrumbs_override_current: data.title,
            heading_width: 'big',
            breadcrumbs_spacing_bottom: 11,
            padding_bottom: '0',
            padding_bottom_mb: '0',
            title_font_size: 'h3',
            title_font_size_mobile: 'h3',
          }}
          location={location}
        />
        <LocationInfo
          location={_get(data, 'location.name')}
          department={_get(data, 'departments[0].name')}
        />
        <Info blok={data} />
        {singleRole?.body.map(el =>
          React.createElement(Components[el.component], {
            key: el._uid,
            blok: el,
            location,
            lang,
            allLanguages: allLanguages,
          }),
        )}
        {layout.footer[0] && <Footer blok={layout.footer[0]} />}
      </Layout>
    )
  }
}

export default JobPostEntry

var LocationInfo = ({ location, department }) => (
  <Container>
    <Row pb={64}>
      <Col width={[1, 1, 1 / 4]}>
        <h5>{location}</h5>
      </Col>
      <Col width={[1, 1, 1 / 4]}>
        <h5>{department}</h5>
      </Col>
    </Row>
  </Container>
)

export var query = graphql`
  query JobPostQuery($id: Int) {
    greenhouseJob(gh_Id: { eq: $id }) {
      title
      location {
        name
      }
      departments {
        name
      }
      gh_Id
      id
      absolute_url
      content
      questions {
        label
        required
        fields {
          name
          type
          values {
            label
            value
          }
        }
      }
      compliance {
        description
        questions {
          fields {
            name
            type
            values {
              label
              value
            }
          }
          label
          required
        }
      }
    }
  }
`
